// extracted by mini-css-extract-plugin
module.exports = {"noItems":"TabNoItems_noItems__2b3vY","noItemsTitle":"TabNoItems_noItemsTitle__1p9Ea"};